import { createLoadActions } from '@copilot/common/store/actionCreators/list';
import { IMemberLinkedInProfile } from '@copilot/common/store/models/redux';
import { LINKEDIN_PROFILE } from './constant';

export const linkedinProfileLoadAction =
    createLoadActions<IMemberLinkedInProfile>(LINKEDIN_PROFILE);
